//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import directHeading from "~/components/content/direct/directHeading.vue";
import directSection from "~/components/content/direct/directSection.vue";
import directActionsBlock from "~/components/content/direct/directActionsBlock.vue";

export default {
  name: "directSectionFilms",
  components: {
    directHeading,
    directSection,
    directActionsBlock,
  },
  data() {
    return {
      texts: [
        "Wekelijks nieuwe sexfilms",
        "Maandelijks nieuwe meiden",
        "Jaarlijks 200+ nieuwe sex avonturen",
      ],
    };
  },
};
